// <head> страницы бесплатного мини-теста: мета на языке страницы, canonical,
// hreflang (русская — в корне, x-default — азербайджанская, 27.10.2026), стили главной (блок теста — оттуда).
import homeCss from "@/components/home/home.css?url";
import chromeCss from "@/components/site/site-chrome.css?url";
import { FREE_TEST_COPY, FREE_TEST_PATH } from "./free-test-copy";
import type { SiteLang } from "@/components/site/SiteChrome";
import { OG_LOCALE, socialMeta } from "@/lib/page-meta";

const SITE = "https://yolutap.com";

export function freeTestHead(lang: SiteLang) {
  const url = SITE + FREE_TEST_PATH[lang];
  return {
    meta: [
      ...socialMeta(FREE_TEST_COPY[lang].meta),
      { property: "og:type", content: "website" },
      { property: "og:url", content: url },
      { property: "og:locale", content: OG_LOCALE[lang] },
    ],
    links: [
      { rel: "canonical", href: url },
      { rel: "alternate", hrefLang: "ru", href: SITE + FREE_TEST_PATH.ru },
      { rel: "alternate", hrefLang: "az", href: SITE + FREE_TEST_PATH.az },
      { rel: "alternate", hrefLang: "en", href: SITE + FREE_TEST_PATH.en },
      { rel: "alternate", hrefLang: "x-default", href: SITE + FREE_TEST_PATH.az },
      { rel: "stylesheet", href: chromeCss },
      { rel: "stylesheet", href: homeCss },
    ],
  };
}
